<template>
	<div class="check-group-container">
		<el-checkbox v-if="checkGroupList.length>0" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleAllChange">{{title}}
		</el-checkbox>
		<el-checkbox-group v-model="checks" @change="handleCheckedChange">
			<el-checkbox v-for="item in checkGroupList" :label="item.code" :key="item.code">{{item.name}}
			</el-checkbox>
		</el-checkbox-group>
	</div>
</template>

<script>
	export default {
		props: ['type', 'title', 'checkGroupList', 'checkedList'],
		data() {
			return {
				checks: [],
				checkAll: false,
				isIndeterminate: false
			}
		},
		watch: {
			checkedList: {
				handler(val) {
					const checkList = val || []
					this.checks = checkList
					this.checkAll = checkList.length == this.checkGroupList.length
					this.isIndeterminate = checkList.length > 0 && checkList.length < this.checkGroupList.length
				},
				immediate: true,
			}
		},
		methods: {
			handleAllChange(val) {
				this.checks = val ? this.checkGroupList.map(item=>item.code) : [];
				this.$emit('checkedChange', this.checks, this.type)
				this.isIndeterminate = false;
			},
			handleCheckedChange(value) {
				this.$emit('checkedChange', value, this.type)
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.checkGroupList.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkGroupList.length;
			}
		}
	}
</script>

<style lang="less">
	.check-group-container {
		padding: 0 10px;
		margin-top: 30px;

		>label {
			margin-bottom: 10px;
		}

		>.el-checkbox-group {
			margin-left: 30px;
			.el-checkbox{
				margin-bottom: 10px;
			}
		}
	}
</style>
